import { required, maxLength } from 'vuelidate/lib/validators'
import { validateRegexData, validateRegexComputed } from './validateRegex'

export const validateData = {
  choicedGroups:{ required },
  form: {
    ...validateRegexData,
    acao: {
      description: { required, maxLength: maxLength(35) },
      centroDeCusto: { required },
      rota_id: { required },
      regex_id: { required },
    },
  },
}

export const validateComputed = {
  ...validateRegexComputed,
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.acao.description.$dirty) return errors
    !this.$v.form.acao.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.acao.description.maxLength && errors.push('Máximo 35 caracteres.')
    return errors
  },
  centroDeCustoErrors() {
    const errors = []
    if (!this.$v.form.acao.centroDeCusto.$dirty) return errors
    !this.$v.form.acao.centroDeCusto.required && errors.push('Centro de custo é obrigatório.')
    return errors
  },
  rotaErrors() {
    const errors = []
    if (!this.$v.form.acao.rota_id.$dirty) return errors
    !this.$v.form.acao.rota_id.required && errors.push('Rota é obrigatória.')
    return errors
  },
  regexIdErrors() {
    const errors = []
    if (!this.$v.form.acao.regex_id.$dirty) return errors
    !this.$v.form.acao.regex_id.required && errors.push('Regex da rota é obrigatória.')
    return errors
  },
  choicedGroupsErrors() {
    const errors = []
    if (!this.$v.choicedGroups.$dirty) return errors
    !this.$v.choicedGroups.required && errors.push('Grupo é obrigatório.')
    return errors
  },
}
